<div class="map-navigation-wrapper">
  <div class="map-navigation-shell d-flex flex-column shadow-sm rounded-2 border cursor-pointer">
    <span
      class="rb-ic rb-ic-arrow-up-frame fs-2xl hover-effect p-2"
      [ngStyle]="{ transform: 'rotate(' + rotateIcon() + 'deg)' }"
      (click)="rotateNorth()"
      placement="start"
      ngbTooltip="Rotate back to north"
      tooltipClass="custom-tooltip"
      [openDelay]="1000"
    >
    </span>
    <span class="map-navigation-divider"> </span>
    <span
      class="rb-ic rb-ic-locator fs-2xl hover-effect p-2"
      [class.sel-menu-item]="isLocationRefreshEnabled()"
      (click)="toggleAutoRefresh()"
      ngbTooltip="Follow current location"
      tooltipClass="custom-tooltip"
      placement="start"
      [openDelay]="1000"
    >
    </span>
    <span class="map-navigation-divider"> </span>
    <span
      class="rb-ic rb-ic-satellite fs-2xl hover-effect p-2"
      [class.sel-menu-item]="mapService.isSatelliteEnabled()"
      [class.rounded-bottom-2]="mapService.isSatelliteEnabled()"
      (click)="switchSatelliteView()"
      ngbTooltip="Change to satellite style"
      tooltipClass="custom-tooltip"
      placement="start"
      [openDelay]="1000"
    >
    </span>
  </div>
  <ng-content></ng-content>
</div>
